import { PolicyEvalDisposition } from '../../../enums';

export const policyActionResultTitleMapper = (
  policyEvalDisposition: PolicyEvalDisposition,
): string => {
  switch (policyEvalDisposition) {
    case PolicyEvalDisposition.MATCH:
      return 'True';
    case PolicyEvalDisposition.NO_MATCH:
      return 'False';
    case PolicyEvalDisposition.EXCEPTION:
      return 'Error';
    case PolicyEvalDisposition.EVALEXCEPTION:
      return 'Error';
    case PolicyEvalDisposition.DISABLED:
      return 'Disabled';
    case PolicyEvalDisposition.INVALID:
      return 'Invalid';
    default:
      throw new Error(`Encountered unsupported policy eval disposition ${policyEvalDisposition}`);
  }
};

export const policyEvalResultToTestIdMapper = (
  policyEvalDisposition: PolicyEvalDisposition,
): string => {
  switch (policyEvalDisposition) {
    case PolicyEvalDisposition.MATCH:
      return 'policy-run-success';
    case PolicyEvalDisposition.NO_MATCH:
      return 'policy-run-failure';
    case PolicyEvalDisposition.EXCEPTION:
      return 'policy-run-exception';
    case PolicyEvalDisposition.EVALEXCEPTION:
      return 'policy-run-evalexception';
    case PolicyEvalDisposition.DISABLED:
      return 'policy-run-disabled';
    case PolicyEvalDisposition.INVALID:
      return 'policy-run-invalid';
    default:
      throw new Error(`Encountered unsupported policy eval disposition ${policyEvalDisposition}`);
  }
};
